import styled from "styled-components";

export const StyledWrapper = styled.div`
  width: 100%;

  section.input-searchbar {
    width: 100%;
    max-width: 450px;
    float: right;
  }
`;
